// 1st Option is always the Default selected
export const PRODUCT_TYPES_OPTIONS = ["GOLD", "SILVER", "PLATINUM", "DIAMOND"];
export const GENDER_OPTIONS = ["MALE", "FEMALE", "UNISEX", "KIDS"];
export const PRODUCT_STATUS_OPTIONS = ["ACTIVE", "INACTIVE"];
